import Modal from "@components/atoms/Modal";
import React from "react";
import FilterSearchScreen from "./FilterSearchScreen";

const FilterSearchScreenModal = ({
  isOpen,
  onClose,
  title,
  customIcon,
  selectionType,
  payloadName,
  sectionName,
  api,
  server_side_search,
  value,
  selectedStyle,
  api_query_key,
  name,
  inputLabel,
  sub_options,
  brandsData,
  brandsLoading,
  defaultList,
}: any) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      headerTitle={title}
      webHeight={"80vh"}
      showScrollbar={false}
      noPadding
      skipKeyboardAware
      skipKeyboardAwareWeb
    >
      <FilterSearchScreen
        onClose={onClose}
        title={title}
        customIcon={customIcon}
        selectionType={selectionType}
        payloadName={payloadName}
        sectionName={sectionName}
        api={api}
        server_side_search={server_side_search}
        value={value}
        selectedStyle={selectedStyle}
        api_query_key={api_query_key}
        name={name}
        inputLabel={inputLabel}
        sub_options={sub_options}
        brandsData={brandsData}
        brandsLoading={brandsLoading}
        defaultList={defaultList}
      />
    </Modal>
  );
};

export default FilterSearchScreenModal;
